export default __webpack_public_path__ + "static/media/deng.95209b04.mp3";